module.exports = __webpack_public_path__ + "images/fb7a2274a11aa3f70a73f2298f7fc09b.png";